import Component from './ColumnChooserRow.component';

export default Component;
